import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Button } from "@mui/material";
import { EditorActionButtons } from "../../../components/button/editor-action-buttons";

import type { PollWithOptions } from "../../../../../poll/server/supabase-poll-service";
import type { NodeKey } from "lexical";
import type { FC } from "react";

export const ChatPollComponent: FC<{
  nodeKey: NodeKey;
  poll: PollWithOptions;
}> = ({ nodeKey, poll }) => {
  const [editor] = useLexicalComposerContext();
  return (
    <EditorActionButtons
      buttons={[]}
      disabled={!editor.isEditable()}
      nodeKey={nodeKey}
      data-analytics-id="lexical-button-list"
    >
      {poll.poll.options.map((button) => (
        <Button
          key={button.id}
          data-analytics-id="lexical-button-list-button-preview"
          sx={{ border: 1, p: "3px" }}
        >
          {button.text}
        </Button>
      ))}
    </EditorActionButtons>
  );
};
